import { makeStyles } from "@material-ui/core/styles";
import { Box, List, ListItemText } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { LegendBoxList, LegendBoxListItem } from "../../legend/LegendBoxComponents";
import clsx from "clsx";
import { memo } from "react";
import { useMapColorState } from "../../../store/MapColorState";
import { modelLevelWithID } from '../../../store/ModelLevelState';
import { useRecoilValue } from "recoil";
import { WX_ID_GSM } from '../../../store/WeatherContentsState';

const useStyles = makeStyles(_ => ({
  flexList: {
    display: "flex",
    padding: 0
  },
  lt100LegendBox: {
    color: "rgb(101, 179, 255)",  //rgb(30, 144, 255)だと凡例パネル上では見づらいため25%ほど明るく
    borderBottom: '4px solid rgb(30, 144, 255)'
  },
  gt100LegendBox: {
    color: "rgb(127, 208, 127)",  //rgb(78, 190, 78)だと凡例パネル上では見づらいため25%ほど明るく
    borderBottom: '4px solid rgb(144, 238, 144)'
  },
  gt160LegendBox: {
    color:"rgb(247, 200, 127)",
    borderBottom: '4px solid rgb(250, 250, 210)'
  },
  listItem: {
    marginLeft: 5
  },
  isoTachWidth: {
    minWidth: 160
  },
  legendText: {
    whiteSpace: "nowrap"
  },
  contour: {
    display: 'inline-block',
    position: 'relative',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '30px',
    height: '5px',
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      top: "22px",
      left: 0,
      width: '35px'
    }
  },
  isotherm: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(128, 0, 0)'
    }
  },
  geoPotential: {
    '&:after': {
      top: 12,
      borderTop: '4px solid rgb(0, 255, 0)'
    }
  },
  icingDark: {
    color: '#000000',
    marginLeft: 5
  },
  icingWite: {
    color: '#c4c2c2',
    marginLeft: 5
  },
  none: {
    display: "none"
  }
}));

function LegendGsm({contents: gsm}) {
  const classes = useStyles();
  const {t} = useTranslation();
  const {isDarkMap} = useMapColorState();
  const level = useRecoilValue(modelLevelWithID(WX_ID_GSM));

  return (
    <Box>
      <LegendBoxList>
        <LegendBoxListItem>
          <List className={clsx(classes.flexList, classes.isoTachWidth)}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('Wind speed')} (kt) ({t('Contour')})</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.listItem}>
              <ListItemText className={classes.lt100LegendBox}>&lt;100</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.listItem}>
              <ListItemText className={classes.gt100LegendBox}>100</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={classes.listItem}>
              <ListItemText className={classes.gt160LegendBox}>160</ListItemText>
            </LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('Temperature')} (°C) ({t('Contour')})</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.isotherm}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem className={clsx(level === "0" && classes.none)}>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('Geo Potential Height')} (m)</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem className={`${classes.contour} ${classes.geoPotential}`}></LegendBoxListItem>
          </List>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <List className={classes.flexList}>
            <LegendBoxListItem>
              <ListItemText className={classes.legendText}>{t('IcingProb')}</ListItemText>
            </LegendBoxListItem>
            <LegendBoxListItem>
              <ListItemText className={clsx(classes.icingWite, !isDarkMap && classes.none)}>＊</ListItemText>
              <ListItemText className={clsx(classes.icingDark, isDarkMap && classes.none)}>✱</ListItemText>
            </LegendBoxListItem>
          </List>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

// export default LegendGsm;
export default memo(LegendGsm);
